// extracted by mini-css-extract-plugin
export default {"day":"styles_day__nTeyX"};